import { jsx } from "react/jsx-runtime";
import { FieldPropsContext } from "../../../../contexts/field-props-context.js";
import { useForm } from "../../../../contexts/form-context.js";
import { useExternalData } from "../../contexts/external-data-context.js";
import { useFormFields } from "../../contexts/form-fields-context.js";
const ReadOnlyField = ({ field, FieldLayout }) => {
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();
  const { requiredIndicator, requiredIndicatorPlacement } = form.requiredIndicatorProperties || {};
  const FieldComponent = componentsById[field.fieldType];
  if (!FieldComponent) {
    return null;
  }
  const fieldProps = {
    ...field.properties,
    id: field.id,
    externalData,
    fieldType: field.fieldType,
    FieldLayout,
    requiredIndicatorType: requiredIndicator,
    requiredIndicatorPlacement
  };
  return /* @__PURE__ */ jsx(FieldPropsContext.Provider, { value: { v2: fieldProps }, children: /* @__PURE__ */ jsx(FieldComponent, { ...fieldProps }) });
};
export {
  ReadOnlyField
};
//# sourceMappingURL=read-only-field.js.map
